module.exports = __webpack_public_path__ + "img/Fragile Things-1.fcf86517.svg";